import { Component, OnInit, Output, EventEmitter, Input, ViewChild } from '@angular/core';
import { TYPEMODULE, LoaderService, NotificationService, ErrorService, ICONS, ACTIONS, EVENTO, CONSTANT, TOOLTIPS, GridDataSource } from '../../../../shared/session/index';
import { ModuleService } from '../shared/module.service';
import { PageEvent, MatPaginator, MatTableDataSource } from '@angular/material';
import { SectionBarComponent } from 'src/app/shared/sectionbar/sectionbar.component';

@Component({
    selector: 'app-module-list',
    templateUrl: 'module-list.component.html',
})

export class ModuleListComponent implements OnInit {
    @ViewChild(MatPaginator) paginator: MatPaginator;
    @Output() onChangeEvent: EventEmitter<any> = new EventEmitter();
    @ViewChild(SectionBarComponent) sectionBarComponent: SectionBarComponent;
    @Input() typeModule: TYPEMODULE;
    @Input() data: any;
    @Input() titlePage: string;

    pageSize: number;
    pageEvent: PageEvent;
    displayedColumns: string[];
    dataSource: GridDataSource;
    msgErrorGet: string;
    selectedRowIndex: number = -1;
    buttonGroup: any;
    showMessageGridEmpty: boolean = false;
    pageSizeOptions: number[] = CONSTANT.pageSizeOptions;

    constructor(private loaderService: LoaderService, private moduleService: ModuleService,
        private notificationService: NotificationService
    ) { }

    ngOnInit() {
        this.pageSize = CONSTANT.pageSize;
        this.pageEvent = new PageEvent();
        this.clearMatPaginator();
        this.msgErrorGet = 'Error al listar los Modulos';
        this.displayedColumns = ['ModuleID', 'Name', 'Descripcion', 'Status'];
        this.buttonGroup = [
            { tooltip: TOOLTIPS.new, icon: ICONS.new, action: ACTIONS.new }
        ];
    }

    handleRowClick(row: any) {
        this.selectedRowIndex = row.ID;
        this.data.modules = { ID: row.ModuleID, Name: row.Name };
        this.changeEvent({ evento: EVENTO.consultar, data: this.data });
    }

    private clearMatPaginator() {
        this.pageEvent.pageIndex = 0;
        this.pageEvent.pageSize = this.pageSize;
        this.pageEvent.length = 0;
    }

    private setMatPaginator() {
        // this.paginator.length = this.pageEvent.length;
        // this.paginator.pageIndex = this.pageEvent.pageIndex;
        // this.paginator.pageSize = this.pageEvent.pageSize;
    }

    searchEmit(data: any) {
        this.buscarModulo(data.filtro, data.aplicacionID);
    }

    changeEvent(event) {
        this.onChangeEvent.emit(event);
    }

    onNew() {
        this.changeEvent({ evento: EVENTO.crear, data: {} });
    }

    pageEventPaginator(value) {
        this.pageEvent = value;
        this.listarPorModulos(this.sectionBarComponent.filtro, this.sectionBarComponent.aplicacionID);
    }

    buscarModulo(filtro: string, aplicacionID: number) {
        this.clearMatPaginator();
        this.listarPorModulos(filtro, aplicacionID);
    }

    fabButtonEmit(action: any) {
        switch (action) {
            case ACTIONS.new:
                this.onNew();
                break;
            default:
                break;
        }
    }

    private listarPorModulos(filtro: string, pAplicacionID: number): void {
        this.loaderService.show();
        this.moduleService.listarPorModulos(filtro, pAplicacionID, this.pageEvent.pageIndex, this.pageEvent.pageSize)
            .subscribe(res => {
                this.dataSource = new GridDataSource(res);
                this.showHideMessageGridEmpty(Number(res.length));
                this.pageEvent.length = res.length;
                this.setMatPaginator();
            },
                error => {
                    this.notificationService.error(this.msgErrorGet);
                    throw error;
                },
                () => {
                    this.loaderService.hide();
                });
    }

    public showHideMessageGridEmpty(rows: number) {
        this.showMessageGridEmpty = false;
        if (rows <= 0) this.showMessageGridEmpty = true;
    }
}

